import { COLORS } from '@/constants/colors';

export const classes = {
  root: {
    backgroundColor: 'white',
    boxShadow: 'none',
    width: '100%',
    left: 0,
    right: 0,
    zIndex: 1100,
    height: { xs: '64px', lg: '84px' },
    display: 'block',
    boxSizing: 'border-box',
    borderBottom: '1px solid rgba(0, 0, 0, 0.05)'
  },
  navContainer: {
    position: 'relative',
    width: '100%',
    height: { xs: '64px', lg: '84px' },
    backgroundColor: 'transparent',
    border: 'none',
    borderRadius: 0,
    boxShadow: 'none',
    display: 'grid',
    // Equal side columns keep page links centered between logo and actions.
    gridTemplateColumns: {
      xs: '1fr auto',
      lg: 'minmax(0, 1fr) auto minmax(0, 1fr)'
    },
    alignItems: 'center',
    columnGap: { xs: 1, lg: 2, xl: 3 },
    px: { xs: 2, md: 3, xl: 4 },
    pt: { xs: '12px', lg: '32px' },
    pb: { xs: '12px', lg: '10px' },
    maxWidth: '1464px',
    margin: '0 auto',
    boxSizing: 'border-box'
  },
  navBrand: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    minWidth: 0
  },
  navLinksDesktop: {
    display: { xs: 'none', lg: 'flex' },
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: { lg: '24px', xl: '32px' },
    minWidth: 0,
    px: { lg: 1, xl: 2 }
  },
  navActions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    minWidth: 0
  },
  logoText: {
    flexGrow: { xs: 1, lg: 0 },
    fontWeight: 800,
    fontSize: {
      xs: '16px',
      sm: '24px'
    },
    color: COLORS.textPrimary,
    textDecoration: 'none'
  },
  justifyBetween: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%'
  },
  menuIcon: {
    display: { lg: 'none' },
    color: {
      xs: COLORS.textPrimary,
      lg: COLORS.primary
    }
  },
  drawer: {
    display: { xs: 'block', lg: 'none' },
    '& .MuiDrawer-paper': {
      boxSizing: 'border-box',
      maxWidth: 320,
      width: '100%'
    }
  },
  navLinks: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: { lg: '32px', xl: '40px' }
  },
  loginBtn: {
    backgroundColor: { xs: 'transparent', lg: '#004AE0' },
    color: { xs: '#4E576B', lg: '#FFFFFF' },
    borderRadius: { xs: '32px', lg: '8px' },
    padding: { xs: '6px 10px', lg: '10px 20px' },
    fontWeight: { xs: 400, lg: 500 },
    fontSize: { xs: '12px', lg: '18px' },
    lineHeight: { xs: '16px', lg: '22px' },
    textTransform: 'none',
    minWidth: 'auto',
    width: { xs: 'auto', lg: '133px' },
    height: { xs: 'auto', lg: '42px' },
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: { xs: 'rgba(78, 87, 107, 0.06)', lg: '#0039B8' },
      boxShadow: 'none'
    }
  },
  signupBtn: {
    backgroundColor: { xs: '#004AE0', lg: '#FFFFFF' },
    color: { xs: '#FFFFFF', lg: '#004AE0' },
    border: { xs: '0 !important', lg: '1px solid #004AE0' },
    borderRadius: { xs: '32px', lg: '8px' },
    padding: { xs: '6px 10px', lg: '10px 20px' },
    fontWeight: { xs: 400, lg: 500 },
    fontSize: { xs: '12px', lg: '18px' },
    lineHeight: { xs: '16px', lg: '22px' },
    textTransform: 'none',
    minWidth: 'auto',
    width: { xs: 'auto', lg: '132px' },
    height: { xs: 'auto', lg: '42px' },
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: { xs: '#0039B8', lg: '#F0F5FF' },
      borderColor: { lg: '#0039B8' },
      color: { xs: '#FFFFFF', lg: '#0039B8' },
      boxShadow: 'none'
    }
  },
  mobileMenuBtn: {
    ml: { xs: 1, sm: 2 },
    display: { lg: 'none' },
    p: 0,
    width: 32,
    height: 32,
    border: '1px solid #EBEDF1',
    borderRadius: '4px',
    color: '#262A34'
  },
  navItem: {
    color: '#000000',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '20px',
    textTransform: 'none',
    padding: 0,
    minWidth: 'auto',
    '&:hover': {
      color: '#004ae0',
      backgroundColor: 'transparent',
      transition: 'color 0.2s ease-in-out'
    },
    '&.active': {
      color: '#004ae0',
      fontWeight: 500,
      textDecoration: 'underline',
      textUnderlineOffset: '6px'
    }
  },
  iconBox: {
    height: { xs: '36px', lg: '48px' },
    width: { xs: '36px', lg: '48px' },
    border: `1px solid ${COLORS.borderColor}`,
    borderRadius: 2,
    mr: { xs: 1, sm: 1.5, lg: 3 },
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  sticky: {
    top: 0
  }
};
